import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "use", "height", "children"];
import { forwardRef } from 'react';
import styled from 'styled-components';
import { useHeight, useMargin } from './Section.hooks';
import { filterProps } from '../../../utils';
import { useMapStylePropsToCSS } from '../../../hooks/useMapStylePropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSection = styled.div.withConfig({
  displayName: "Section__StyledSection",
  componentId: "sc-17v1jrt-0"
})(props => {
  return Object.assign({
    height: props.$height
  }, props.$margin, props.$cssStyles);
});
const SectionWithRef = (_ref, ref) => {
  let {
      flush = false,
      use = 'default',
      height: heightProp,
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    styleProps
  } = filterProps(restProps, {
    labelable: true
  });
  const cssStyles = useMapStylePropsToCSS(styleProps);
  const margin = useMargin(use, flush);
  const height = useHeight(heightProp);
  return /*#__PURE__*/_jsx(StyledSection, {
    ref: ref,
    $margin: margin,
    $height: height,
    $cssStyles: cssStyles,
    children: children
  });
};
export const Section = /*#__PURE__*/forwardRef(SectionWithRef);